<template>
  <div class="tw:mt-9 tw:mr-6 tw:flex tw:flex-col tw:w-[320px]">
    <div class="tw:overflow-hidden tw:h-[38px] tw:relative tw:flex tw:items-center tw:justify-center">
      <transition name="slide">
        <p :key="headerIndex" class="tw:text-xs tw:absolute tw:font-bold tw:text-center tw:w-full">
          {{ $t(bannerHeaders[headerIndex]) }}
        </p>
      </transition>
    </div>

    <div class="preview-card tw:h-[338px] tw:overflow-hidden tw:flex tw:flex-col tw:text-xs">
      <div
        class="tw:shrink-0 tw:bg-white tw:rounded-t-xl tw:border tw:border-gray-300 tw:overflow-hidden tw:h-[38px] tw:flex tw:items-center tw:px-3">
        <p v-html="$t('plus_animation_subtext_plus')"></p>
      </div>

      <div class="tw:h-[260px] tw:relative tw:overflow-hidden tw:rounded-b-xl">
        <div class="tw:relative tw:h-[100px]">
          <div
            class="tw:h-[100px] tw:bg-cover tw:bg-center tw:bg-no-repeat"
            :style="{ backgroundImage: `url(${hotelImg})` }" />

          <div class="tw:absolute tw:bottom-2 tw:left-2 tw:overflow-hidden">
            <transition name="promo">
              <div
                v-if="showImageOverlay"
                class="tw:inline-flex tw:items-center tw:border tw:border-gray-800 tw:rounded-full tw:py-1 tw:px-3 tw:gap-x-1 tw:bg-white">
                <img :src="giftImg" alt="Promo" class="tw:h-5 tw:w-5" />
                <p class="tw:font-bold tw:text-sm">Promo</p>
              </div>
            </transition>
          </div>
        </div>

        <div
          class="card-body-panel tw:h-[265px] tw:relative tw:overflow-hidden tw:bg-gray-100 tw:px-3"
          :class="{ 'card-body-panel--expanded': showExpandedBody }">
          <div class="card-body-stack tw:h-[265px]">
            <div class="card-body-current" :class="{ 'card-body-content-hidden': showExpandedBody }">
              <div class="tw:border tw:border-green-300 tw:bg-green-100 tw:rounded-xl tw:p-3 tw:mt-3">
                <div class="tw:overflow-hidden tw:h-[20px] tw:relative">
                  <div class="tw:absolute tw:flex tw:items-center tw:gap-x-2">
                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.73755 7.83921L6.31694 9.41861L9.47573 6.25982M13.4242 7.83921C13.4242 11.3621 9.1125 13.9149 7.61316 14.6961C7.45099 14.7806 7.36991 14.8229 7.25743 14.8448C7.16981 14.8618 7.04346 14.8618 6.95584 14.8448C6.84336 14.8229 6.76228 14.7806 6.60011 14.6961C5.10077 13.9149 0.789062 11.3621 0.789062 7.83921V4.85227C0.789062 4.2209 0.789062 3.90521 0.892324 3.63385C0.983545 3.39412 1.13178 3.18022 1.32421 3.01064C1.54203 2.81867 1.83762 2.70783 2.42879 2.48614L6.66299 0.898313C6.82716 0.836748 6.90925 0.805965 6.9937 0.793762C7.0686 0.782939 7.14467 0.782939 7.21957 0.793762C7.30402 0.805965 7.38611 0.836748 7.55028 0.898313L11.7845 2.48614C12.3757 2.70783 12.6712 2.81867 12.8891 3.01064C13.0815 3.18022 13.2297 3.39412 13.3209 3.63385C13.4242 3.90521 13.4242 4.2209 13.4242 4.85227V7.83921Z"
                        stroke="#1391D2"
                        stroke-width="1.57145"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                    <p class="tw:font-bold tw:text-black tw:text-sm">{{ $t('hotel_site_label') }}</p>
                  </div>
                </div>

                <div class="tw:flex tw:items-end tw:justify-between">
                  <div class="tw:overflow-hidden tw:h-[28px] tw:relative tw:w-[110px]">
                    <p class="tw:absolute tw:font-bold tw:text-xl">
                      {{ formatCurrency(150, { divideBy100: false }) }}
                    </p>
                  </div>
                  <div
                    class="tw:bg-green-800 tw:rounded-lg tw:text-white tw:flex tw:text-sm tw:px-3 tw:py-[6px] tw:items-center tw:font-bold">
                    {{ $t('view_deal_cta') }}
                    <ChevronRight class="tw:size-[18px]" />
                  </div>
                </div>
              </div>

              <div class="tw:h-[50px] tw:mt-2 tw:bg-white tw:border tw:rounded-xl tw:border-gray-300 tw:px-3 tw:py-2">
                <div class="tw:overflow-hidden tw:h-[18px] tw:relative">
                  <p class="tw:absolute tw:text-xs tw:w-full">
                    <span class="tw:font-bold">{{ formatCurrency(160, { divideBy100: false }) }}</span>
                    Hotels.com
                  </p>
                </div>
                <div class="tw:overflow-hidden tw:h-[18px] tw:relative">
                  <p class="tw:absolute tw:text-xs tw:w-full">
                    <span class="tw:font-bold">{{ formatCurrency(165, { divideBy100: false }) }}</span>
                    Expedia
                  </p>
                </div>
              </div>
            </div>

            <div class="card-body-next tw:h-[265px]" :class="{ 'card-body-content-visible': showExpandedBody }">
              <div class="tw:flex tw:gap-2 tw:items-center tw:h-[50px]">
                <div
                  class="tw:h-[28px] tw:inline-flex tw:items-center tw:border tw:border-blue-700 tw:bg-blue-100 tw:rounded-full tw:px-3 tw:gap-x-1">
                  <img :src="giftImg" alt="Promo" class="tw:h-5 tw:w-5" />
                  <p class="tw:font-bold tw:text-sm">{{ $t('hotel_promo_badge') }}</p>
                </div>
              </div>
              <div class="tw:h-[112px] tw:bg-blue-100 tw:rounded-xl tw:text-sm tw:p-3">
                <div class="tw:flex tw:gap-3">
                  <div aria-hidden="true" class="tw:bg-orange-700 tw:p-2 tw:rounded-full tw:shrink-0">
                    <img :src="GiftImg" alt="Gift Icon" class="tw:w-6 tw:h-6 tw:brightness-0 tw:invert" />
                  </div>
                  <div class="tw:grow tw:min-w-0">
                    <p class="tw:font-bold tw:w-full tw:truncate">{{ $t('ho_room_upgrade_title') }}</p>
                    <p class="tw:w-full tw:truncate">{{ $t('plus_animation_offer_text') }}</p>
                  </div>
                </div>
                <div
                  class="tw:mt-3 tw:bg-white tw:font-bold tw:border tw:border-gray-800 tw:rounded-lg tw:py-2 tw:text-center">
                  {{ $t('hotel_offers_official_site_badge') }}
                </div>
              </div>
              <div
                class="tw:h-[91px] tw:bg-white tw:rounded-b-xl tw:text-sm tw:px-3 tw:flex tw:flex-col tw:justify-center">
                <div class="tw:flex tw:items-center tw:gap-x-1 tw:mb-1">
                  <img :src="PhoneImg" alt="Phone" class="tw:w-5 tw:h-5" />
                  <p class="tw:text-blue-700">{{ $t('hotel_phone_example') }}</p>
                </div>
                <div class="tw:flex tw:items-center tw:gap-x-1 tw:mb-1">
                  <img :src="emailIcon" alt="Email" class="tw:w-5 tw:h-5" />
                  <p class="tw:text-blue-700">{{ $t('hotel_email_example') }}</p>
                </div>
                <div class="tw:flex tw:items-center tw:gap-x-1">
                  <img :src="locationIcon" alt="Location" class="tw:w-5 tw:h-5" />
                  <p>{{ $t('hotel_address_example') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

import ChevronRight from '@/components/icons/ChevronRight.svg?component'

import { useFormatting } from '@/composables/useFormatting'

const ANIMATION_STATE_COUNT = 3

const hotelImg = new URL(
  '/src/assets/img/rate-connect/plus-upsell/rate-connect-plus-upsell-banner-animation-hotel.jpeg',
  import.meta.url
)
const giftImg = new URL('/src/assets/img/studio-plus/GiftIcon.svg', import.meta.url)
const PhoneImg = new URL('/src/assets/img/studio-plus/PhoneIcon.svg', import.meta.url)
const emailIcon = new URL('/src/assets/img/hotel-offers/icons/UI/email.png', import.meta.url)
const locationIcon = new URL('/src/assets/img/hotel-offers/icons/UI/location.png', import.meta.url)
const GiftImg = new URL('/src/assets/img/studio-plus/GiftIcon.svg', import.meta.url)

const { formatCurrency } = useFormatting()
const animationState = ref(0)
let intervalId = null

const bannerHeaders = ['plus_animation_header_no_plus', 'plus_animation_header_plus']

const headerIndex = computed(() => (animationState.value === 0 ? 0 : 1))
const showImageOverlay = computed(() => animationState.value >= 1)
const showExpandedBody = computed(() => animationState.value >= 2)

const advanceAnimationState = () => {
  animationState.value = (animationState.value + 1) % ANIMATION_STATE_COUNT
}

onMounted(() => {
  intervalId = setInterval(advanceAnimationState, 3000)
})

onBeforeUnmount(() => {
  if (intervalId) clearInterval(intervalId)
})
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter-from {
  transform: translateY(-100%);
  opacity: 0;
}

.slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.slide-enter-to,
.slide-leave-from {
  transform: translateY(0);
  opacity: 1;
}

.promo-enter-active {
  transition:
    transform 0.5s ease,
    opacity 0.5s ease;
}

.promo-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.promo-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.card-body-panel {
  transition: transform 0.45s ease;
}

.card-body-panel--expanded {
  transform: translateY(-100px);
}

.card-body-stack {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.card-body-current,
.card-body-next {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.card-body-current {
  transition: opacity 0.1s ease;
}

.card-body-content-hidden {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.1s ease;
}

.card-body-next {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.1s ease;
}

.card-body-content-visible {
  opacity: 1;
  pointer-events: auto;
  transition: opacity 0.12s ease 0.06s;
}
</style>
